import React from 'react';
import { Link } from 'react-router-dom';

const C = {
  ink: '#344767',
  muted: '#8392ab',
  border: '#e9ecef',
  primary: '#5e72e4',
};

const navBtn = {
  padding: '10px 18px',
  borderRadius: 10,
  fontWeight: 700,
  fontSize: 14,
  textDecoration: 'none',
  display: 'inline-block',
};

export default function PublicNav() {
  return (
    <header
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px 24px',
        background: '#fff',
        borderBottom: `1px solid ${C.border}`,
        position: 'sticky',
        top: 0,
        zIndex: 10,
      }}
    >
      <Link to="/home" style={{ textDecoration: 'none', color: C.ink, fontWeight: 800, fontSize: 18 }}>
        NextFollowUp
      </Link>
      <nav style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
        <Link to="/home" style={{ ...navBtn, color: C.muted }}>
          Product
        </Link>
        <Link to="/contact-sales" style={{ ...navBtn, color: C.muted }}>
          Contact sales
        </Link>
        <Link to="/login" style={{ ...navBtn, background: C.primary, color: '#fff' }}>
          Sign in
        </Link>
      </nav>
    </header>
  );
}
